import { Lifecycle } from '@packages/events/Lifecycle';
import { call } from '@packages/functions';
import { createMemo, renderChildren } from '@packages/react';
import React, { Fragment, ReactElement, useContext, useRef } from 'react';
import { Context } from './context';
import { TabObject } from './TabContainer';

interface TabContentProps {
    component?: any;
    swipeable?: boolean;
    swipeableProps?: {
        [name: string]: any;
    };
    activeTabProps?: {
        [name: string]: any;
    };
}

/**
 *
 * @param props
 * @returns {*}
 * @constructor
 */
export const TabContent = createMemo<TabContentProps & any>(
    (props): ReactElement => {
        const { swipeable, swipeableProps, component, activeTabProps, ...rest } = props;

        const [state, actions] = useContext(Context);
        const actions$ = useRef<any>(null);

        const index = state.get('index');
        const tabs = state.get('tabs');
        const showTabs = state.get('showTabs');

        const RootComponent = component || Fragment;

        const handleHeight = () => {
            if (actions$.current?.updateHeight) {
                setTimeout(() => {
                    call(actions$.current.updateHeight);
                }, 200);
            }
        };

        // useResize(() => {
        //     if ( actions$.current?.updateHeight ) {
        //         call(actions$.current.updateHeight);
        //     }
        // });

        const children$ = tabs.map((tab: TabObject, id) => {
            if (showTabs && typeof showTabs === 'function' && !showTabs(tab)) {
                return null;
            }

            const empty = <div key={id} />;

            if (id !== index) {
                if (swipeable) {
                    if (!tab._mounted) {
                        return empty;
                    }
                } else {
                    return empty;
                }
            }

            if (!tab.component) {
                return null;
            }

            if (!tab._mounted) {
                actions.setMounted(id);
            }

            let Component = tab.component;

            if (React.isValidElement(Component)) {
                Component = { ...Component };
                Component.props = {
                    ...Component.props,
                    ...activeTabProps,
                    onLoad() {
                        handleHeight();
                    },
                };
            }

            return (
                <Lifecycle key={id} onMount={handleHeight}>
                    {renderChildren(Component, {
                        key: id,
                        tab,
                    })}
                </Lifecycle>
            );
        });

        // if ( swipeable ) {
        //     const swipeableProps$: { [ key: string ]: any } = {
        //         ...( swipeableProps || {} )
        //     };

        //     if ( !swipeableProps$.axis ) {
        //         swipeableProps$.axis = 'x';
        //     }

        //     if ( !swipeableProps$.index ) {
        //         swipeableProps$.index = index;
        //     }

        //     if ( typeof swipeableProps$.animateHeight === 'undefined' ) {
        //         swipeableProps$.animateHeight = true;
        //     }

        //     swipeableProps$.style = {
        //         ...( swipeableProps$.style || {} ),
        //         width: '100%'
        //     };

        //     swipeableProps$.action = ( actions ) => {
        //         actions$.current = actions;
        //     };

        //     swipeableProps$.onSwitching = ( index: number, action: 'move' | 'end' ) => {
        //         const diff$ = index - parseInt(`${ index }`);
        //         const index$ = Math.round(index);

        //         if (
        //             state.get('index') !== index$ &&
        //             (
        //                 !isBetween(diff$, 0.30, 0.7, false) ||
        //                 action === 'end'
        //             )
        //         ) {
        //             actions.setTab(index$);
        //             if ( swipeableProps ) {
        //                 call(swipeableProps.onSwitching, index, action);
        //             }
        //         }
        //     };

        //     children$ = (
        //         <SwipeableViews { ...swipeableProps$ }>{ IF(!!actions$, children$) }</SwipeableViews>
        //     ) as any;
        // }

        return <RootComponent {...rest}>{children$}</RootComponent>;
    },
    {
        displayName: 'TabContent',
    },
);
